import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const sortTableStyles = makeStyles((theme) => ({
    sortTable: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        borderRadius: '3px',

        '& .sort-table': {
            '&-row': {
                margin: 0,
                padding: 0,
                [theme.breakpoints.up('sm')]: {
                    display: 'table',
                    tableLayout: 'fixed',
                    width: '100%',
                    maxWidth: '100%',
                },
                '&-tablet-split': {
                    [theme.breakpoints.down('md')]: {
                        display: 'flex',
                    },
                    [theme.breakpoints.down('sm')]: {
                        display: 'block',
                    },
                    '&-column': {
                        width: '50%',
                        '& .sort-table-row-cell': {
                            display: 'block',
                        },

                    },

                },
                '&-cell': {
                    [theme.breakpoints.up('sm')]: {
                        display: 'table-cell',
                        verticalAlign: 'top',
                    },
                    wordBreak: 'break-word',
                    padding: theme.spacing(1),
                    '&-lg': {
                        [theme.breakpoints.up('md')]: {
                            width: '10rem',
                        },
                    },
                    '&-name': {
                        display: 'flex',
                        wordBreak: 'break-word',
                        '& svg': {
                            '& + div': {
                                marginLeft: theme.spacing(.5),
                            },
                        },
                        '&-text': {
                            '&:first-child': {
                                [theme.breakpoints.up('sm')]: {
                                    marginLeft: theme.spacing(1.5),
                                },
                            },
                        },
                    },
                    '&-actions': {
                        [theme.breakpoints.up('md')]: {
                            display: 'flex',
                        },
                        '& > button + button': {
                            [theme.breakpoints.up('md')]: {
                                marginLeft: theme.spacing(1),
                            },
                            [theme.breakpoints.down('sm')]: {
                                marginTop: theme.spacing(.5),
                            },
                        },
                    },
                    '&-status': {
                        display: 'flex',
                        '&-icon': {
                            width: '1rem',
                            height: '1rem',
                            flex: '0 0 auto',
                            marginRight: theme.spacing(.5),
                            '&.warning': {
                                fill: tcsmColors.yellow,
                            },
                        },
                    },
                    '&.icon-row-title': {
                        [theme.breakpoints.up('sm')]: {
                            paddingLeft: theme.spacing(2.5),
                        },
                    },
                    '& .icon-button-cell': {
                        display: 'flex',
                        '& button': {
                            '& + button': {
                                marginLeft: theme.spacing(1.5),
                            },
                        },
                    },
                },
            },
            '&-content': {
                borderTop: `1px solid ${tcsmColors.greySeven}`,
                '& >.sort-table-row': {

                    '&:nth-child(even)': {
                        backgroundColor: tcsmColors.greySeven,
                    },
                },
                '& .table-pagination': {
                    padding: theme.spacing(1),
                    borderTop: `1px solid ${tcsmColors.greySeven}`,
                },
                '& .clergy-icon': {
                    fill: tcsmColors.blue,
                    width: '1rem',
                    height: '1rem',
                    flex: '0 0 auto',
                },
            },
        },

    },

    sortTableScrollable: {

        
        [theme.breakpoints.between('sm', 'lg')]: {
            overflowX: 'auto',

            '& .sort-table': {
                '&-scrollable-inner': {
                    minWidth: '64rem',
                },
                '&-row-cell': {
                    wordBreak: 'normal',
                },
            },
        },
    },


}));



